// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__Gi59-","rotation":"loader_rotation__1bnP9","animloader":"loader_animloader__gu-tz"};